import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { StreamChannelType } from '@/api/apis/chat';
import { OrganType, DonorType } from '@/api/apis/case';

export type ChatFilters = {
  organTypes: OrganType[];
  donorTypes: DonorType[];
  chatTypes: StreamChannelType[];
  unreadOnly: boolean;
};

export const DEFAULT_CHAT_FILTERS: ChatFilters = {
  organTypes: [],
  donorTypes: [],
  chatTypes: [],
  unreadOnly: false,
};

type ChatFiltersStore = ChatFilters & {
  hydrated: boolean;
  setFilters: (f: Partial<ChatFilters>) => void;
  markHydrated: () => void;
};

export const useChatFiltersStore = create<ChatFiltersStore>()(
  persist(
    (set) => ({
      ...DEFAULT_CHAT_FILTERS,
      hydrated: false,
      setFilters: (f) => set((s) => ({ ...s, ...f })),
      markHydrated: () => set({ hydrated: true }),
    }),
    {
      name: 'chat-filters',
      version: 1,
      onRehydrateStorage: () => (state) => {
        state?.markHydrated();
      },
    },
  ),
);
